import LogInCode from "./LogInCode";
import LogInNumber from "./LogInNumber";
import React, { useState, useEffect } from "react";

export default function Container({
  changeUserInformation,
  beforeJoinClub = false,
}) {
  const [modal, setmodal] = useState(0);
  const [loginkey, setloginkey] = useState("");
  const [number, setnumber] = useState("");
  const [name, setname] = useState("");
  const [isNew, setIsNew ] = useState(0);
  const [family, setfamily] = useState("");
  let SetNumber = (e) => {
    setnumber(e.target.value);
  };
  let SetIsNew = (e) => {
    console.log(e)
    setIsNew(e);
  };
  let SetFamily = (e) => {
    setfamily(e.target.value);
  };
  let SetName = (e) => {
    setname(e.target.value);
  };
  function changemodal(modalNumber) {
    setmodal(modalNumber);
  }
  function LoginKey(loginKey) {
    setloginkey(loginKey);
  }
  function Back() {
    setmodal(0);
  }


  return (
    <>
      <div style={{ direction: "rtl" }}>
        {/* <!-- Modal --> */}
        <div
          className="modal fade hide"
          id="ModalNumber"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header d-flex flex-row justify-content-between">
                {modal == 0 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    className="btn border"
                    style={{ boxShadow: "none" }}
                    onClick={Back}
                  >
                    بازگشت
                  </button>
                )}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  id="CloseModal"
                ></button>
              </div>

              {modal == 0 ? (
                <LogInNumber
                  SetNumber={SetNumber}
                  number={number}
                  SetFamily={SetFamily}
                  family={family}
                  SetName={SetName}
                  SetIsNew={SetIsNew}
                  name={name}
                  login={LoginKey}
                  ChangeModal={changemodal}
                />
              ) : (
                <LogInCode
                  ChangeModal={changemodal}
                  SetName={SetName}
                  name={name}
                  isNew={isNew}
                  SetIsNew={SetIsNew}
                  loginkey={loginkey}
                  SetNumber={SetNumber}
                  changeUserInformation={changeUserInformation}
                  number={number}
                  beforeJoinClub={beforeJoinClub}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
